<template>
    <div class="pesticide-detection">
        <!-- 搜索筛选区域 -->
        <el-card class="search-card">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item label="样品名称">
                    <el-input v-model="searchForm.sampleName" placeholder="请输入样品名称"></el-input>
                </el-form-item>

                <!-- 日期范围选择器 -->
                <el-form-item label="检测日期">
                    <el-date-picker v-model="searchForm.dateRange" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                        @change="handleDateChange">
                    </el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="handleSearch">查询</el-button>
                    <el-button @click="resetSearch">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 检测列表 -->
        <el-card class="table-card">
            <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="sampleName" label="样品名称" align="center"></el-table-column>
                <el-table-column prop="sampleNumber" label="样品编号" align="center"></el-table-column>
                <el-table-column prop="projectType" label="项目类型" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.projectType === 1 ? '农残' :
                            scope.row.projectType === 2 ? '食品' : '胶体金' }}
                    </template>
                </el-table-column>
                <el-table-column prop="deviceCode" label="设备编号" align="center"></el-table-column>
                <el-table-column prop="testProject" label="检测项目" align="center"></el-table-column>
                <el-table-column prop="detectionValue" label="检测值" align="center"></el-table-column>
                <el-table-column prop="unit" label="单位" align="center"></el-table-column>
                <el-table-column prop="detectionResultText" label="检测结果" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.detectionResult === 0 ? 'success' : 'danger'">
                            {{ scope.row.detectionResult === 0 ? '合格' : '不合格' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="detectionResultText" label="检测结果描述" align="center"></el-table-column>
                <el-table-column prop="absorbance" label="吸光度" align="center"></el-table-column>
                <el-table-column prop="inhibitionRatio" label="抑制率" align="center"></el-table-column>
                <el-table-column prop="detectionMethod" label="检测方法（胶体金才有）" align="center"></el-table-column>
                <el-table-column prop="samplingCompany" label="抽样单位(公司)" align="center"></el-table-column>
                <el-table-column prop="samplingPeople" label="抽样人" align="center"></el-table-column>
                <el-table-column prop="samplingPhone" label="抽样人联系方式" align="center"></el-table-column>
                <el-table-column prop="samplingDate" label="抽样日期" align="center" width="160"></el-table-column>
                <el-table-column prop="samplingCardinalNumber" label="抽样基数" align="center"></el-table-column>
                <el-table-column prop="cardinalNumberUnit" label="基数单位" align="center"></el-table-column>
                <el-table-column prop="sampleSource" label="样品来源" align="center"></el-table-column>
                <el-table-column prop="sampleBatch" label="样品批次" align="center"></el-table-column>
                <el-table-column prop="detectionCompany" label="检测单位(公司)" align="center"></el-table-column>
                <el-table-column prop="detectionPeople" label="检测人" align="center"></el-table-column>
                <el-table-column prop="detectionPhone" label="检测人联系方式" align="center"></el-table-column>
                <el-table-column prop="detectionDate" label="检测日期" align="center" width="150"></el-table-column>
                <el-table-column prop="clientCompany" label="受检单位(公司)" align="center"></el-table-column>
                <el-table-column prop="clientPeople" label="受检人" align="center"></el-table-column>
                <el-table-column prop="clientPhone" label="受检人电话" align="center"></el-table-column>
                <el-table-column prop="recheckCompany" label="复核单位(电话)" align="center"></el-table-column>
                <el-table-column prop="recheckPeople" label="复核人" align="center"></el-table-column>
                <el-table-column prop="recheckPhone" label="复核人联系方式" align="center"></el-table-column>
                <el-table-column prop="recheckDate" label="复核日期" align="center"></el-table-column>
                <el-table-column prop="locationSampling" label="采样地点" align="center"></el-table-column>
                <el-table-column prop="locationDetection" label="检测地点" align="center"></el-table-column>
                <el-table-column prop="locationRecheck" label="复核地点" align="center"></el-table-column>
                <el-table-column prop="createdPerson" label="创建人" align="center"></el-table-column>
                <el-table-column prop="createdTime" label="创建时间" align="center"></el-table-column>
                <el-table-column prop="updatePerson" label="修改人" align="center"></el-table-column>
                <el-table-column prop="updateTime" label="修改时间" align="center"></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
import { getList } from "@/api/pesticide";
export default {
    data() {
        return {
            // 搜索表单
            searchForm: {
                sampleName: null,    // 默认 null
                dateRange: [],      // 日期范围选择器绑定
                startTime: '',      // 传给后端
                endTime: ''         // 传给后端
            },

            // 表格数据
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            selectedRows: [],

            formVisible: false,
            formData: {},
            formRules: {}
        };
    },
    mounted() {
        this.setDefaultWeek(); // 设置默认最近一周
        this.loadTableData();
    },
    methods: {
        // 设置默认最近一周
        setDefaultWeek() {
            const now = new Date();
            const end = this.formatDate(now);
            const start = this.formatDate(new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000));

            // 给范围选择器赋值
            this.searchForm.dateRange = [start, end];
            // 同时给后端参数赋值
            this.searchForm.startTime = start;
            this.searchForm.endTime = end;
        },

        // 日期变化时同步更新 startTime endTime
        handleDateChange(val) {
            if (val && val.length === 2) {
                this.searchForm.startTime = val[0];
                this.searchForm.endTime = val[1];
            } else {
                this.searchForm.startTime = '';
                this.searchForm.endTime = '';
            }
        },

        // 日期格式化
        formatDate(date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        // 加载数据
        loadTableData() {
            const params = {
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                sampleName: this.searchForm.sampleName,
                startTime: this.searchForm.startTime,
                endTime: this.searchForm.endTime
            };
            getList(params).then(res => {
                this.tableData = res.data.records || res.data;
                this.totalCount = res.data.length || 0;
            });
        },

        // 搜索
        handleSearch() {
            this.currentPage = 1;
            this.loadTableData();
        },

        // 重置
        resetSearch() {
            this.searchForm = {
                sampleName: null,
                dateRange: [],
                startTime: '',
                endTime: ''
            };
            this.setDefaultWeek(); // 重置后恢复最近一周
            this.currentPage = 1;
            this.loadTableData();
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.loadTableData();
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.loadTableData();
        },

        handleSelectionChange(rows) {
            this.selectedRows = rows;
        },

        // 删除
        handleDelete(row) {
            this.$confirm(`确定要删除【${row.sampleName}】的检测记录吗?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$message.success("删除成功");
                this.loadTableData();
            }).catch(() => {
                this.$message.info("已取消删除");
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.pesticide-detection {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

.search-card {
    margin-bottom: 20px;
}

.table-card {
    .pagination-container {
        margin-top: 15px;
        text-align: right;
    }
}
</style>